import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

import HeroSection from "../components/empresas/empresasInicioo/banner";
import CarouselCards from "../components/cards";
import SecondaryBanner from "../components/SecondaryBanner";
import BannerEmpresas2 from "../components/empresas/empresasInicioo/BannerEmpresas2";
import MfaConfigurator from "../components/auth/MfaConfigurator";
import useAuth from "../hooks/useAuth";
import { useEmpresasLanguage } from "../context/EmpresasLanguageContext";
import { empresasSectores } from "../data/financialIntelligenceHealthcare";
import bancoInicio from "../assets/bancoInicio.png";
import dineroInicio from "../assets/dineroInicio.png";
import relojInicio from "../assets/relojInicio.png";
import sectorSalud from "../assets/sector-salud.jpg";
import sectorConstruccion from "../assets/sector-construccion.jpg";
import sectorCorporativo from "../assets/sector-corporativo.jpg";

const cardIcons = [bancoInicio, dineroInicio, relojInicio];
const sectorImages = {
  salud: sectorSalud,
  construccion: sectorConstruccion,
  corporativo: sectorCorporativo,
};

function Empresas() {
  const { isAuthenticated } = useAuth();
  const { t, lang } = useEmpresasLanguage();
  const e = t.empresas;
  const sectores = empresasSectores[lang] || empresasSectores.es;

  const carouselItems = e.cards.map((card, index) => ({
    ...card,
    icon: cardIcons[index],
  }));

  return (
    <div className="flex flex-col items-center bg-gray-200 overflow-x-hidden">
      <HeroSection />

      <section className="w-full bg-white py-14 px-6 sm:px-10 lg:px-16">
        <div className="max-w-6xl mx-auto">
          <p className="text-[11px] font-semibold uppercase tracking-[0.3em] text-slate-400">
            MEU Aliado Empresas
          </p>
          <h2 className="mt-3 text-3xl sm:text-4xl font-extrabold text-[#220365]">{sectores.title}</h2>
          <p className="mt-3 text-slate-600 max-w-2xl text-lg">{sectores.subtitle}</p>
          <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5">
            {sectores.items.map((sector) => {
              const image = sectorImages[sector.id];
              const isHash = sector.path.includes("#");
              const className =
                "group overflow-hidden rounded-3xl border border-slate-200 bg-white hover:border-[#220365]/40 transition shadow-sm flex flex-col";
              const content = (
                <>
                  <div className="relative h-44 sm:h-48 overflow-hidden">
                    <img
                      src={image}
                      alt={sector.title}
                      className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#0F172A]/55 via-[#0F172A]/10 to-transparent" />
                    <span className="absolute top-4 right-4 rounded-full bg-white/90 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.18em] text-slate-600">
                      {sector.badge}
                    </span>
                  </div>
                  <div className="p-6 flex flex-col flex-1">
                    <h3 className="text-xl font-extrabold text-[#220365]">{sector.title}</h3>
                    <p className="mt-2 text-slate-600 leading-relaxed flex-1">{sector.description}</p>
                    <span className="mt-5 inline-flex items-center gap-2 text-sm font-bold text-[#220365]">
                      {sectores.explore}
                      <ArrowRight className="w-4 h-4 transition group-hover:translate-x-1" />
                    </span>
                  </div>
                </>
              );
              return isHash ? (
                <a key={sector.id} href={sector.path} className={className}>
                  {content}
                </a>
              ) : (
                <Link key={sector.id} to={sector.path} className={className}>
                  {content}
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      <div id="soluciones" className="w-full scroll-mt-28">
        <CarouselCards bgColor="#220365" textColor="#220365" items={carouselItems} />
      </div>
      <BannerEmpresas2
        text={e.banner2Text}
        buttonText={e.banner2Button}
        buttonPath={e.cards[0]?.path}
      />
      {isAuthenticated && (
        <div className="w-full px-6 py-10 md:px-20">
          <MfaConfigurator variant="empresas" />
        </div>
      )}
      <SecondaryBanner
        bgColor="#341d97"
        text={e.secondaryText}
        highlightText={e.secondaryHighlight}
      />
    </div>
  );
}

export default Empresas;
